export default __webpack_public_path__ + "static/media/choptavalley.79fb3f51.jpg";